export function formatLabelTofit (str, maxwidth = 12, splitchar = ' ') {
  // This functions splits the str into array of str, chartjs needs it to show better the legend

  // just to improve lines break
  str = str.replace('-', ' - ')

  const sections = []
  const words = str.split(splitchar)
  let temp = ''

  words.forEach(function (item, index) {
    if (temp.length > 0) {
      const concat = temp + ' ' + item

      if (concat.length > maxwidth) {
        sections.push(temp)
        temp = ''
      } else {
        if (index === (words.length - 1)) {
          sections.push(concat)
          return
        } else {
          temp = concat
          return
        }
      }
    }

    if (index === (words.length - 1)) {
      sections.push(item)
      return
    }

    if (item.length < maxwidth) {
      temp = item
    } else {
      sections.push(item)
    }
  })

  return sections
}
